var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.6C14.6,63.6,0.4,49.4,0.4,32S14.6,0.4,32,0.4S63.6,14.5,63.6,32S49.4,63.6,32,63.6z M32,5.2 C17.2,5.2,5.2,17.2,5.2,32s12,26.8,26.8,26.8s26.8-12,26.8-26.8S46.8,5.2,32,5.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,43.9l-2.9-5.5c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0l-2.7,1.7l-4.8-8.6c0-0.1-0.1-0.1-0.2-0.1h-4.6 v-8.1c0-0.1-0.1-0.2-0.2-0.2h-8.8c-0.1,0-0.2,0.1-0.2,0.2v4c-6.5,0.7-11.7,6.4-11.7,13c0,3.7,1.3,6.7,3.9,9.3 c2.5,2.5,5.8,3.9,9.3,3.9c5.5,0,10.6-3.7,12.3-8.9l3,4.7c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l7.6-5 C50.2,44.1,50.3,44,50.2,43.9z M32.7,43.2L32.7,43.2c-0.1,0.1-0.1,0.1-0.1,0.2c-0.9,1.6-2.3,2.7-4.1,3.3c-1.9,0.2-3.6,0.2-5.2-0.8 c-1.7-0.9-2.8-2.4-3.3-4.1c-0.5-1.9-0.3-3.7,0.6-5.1l0.1-0.1c0,0,0,0,0-0.1c0.9-1.7,2.3-2.8,4.1-3.3c0.1,0,0.3-0.1,0.4-0.1 c0.1,0,0.1,0,0.2,0v5.2c0,0.1,0.1,0.2,0.2,0.2h7.6C33.8,40.1,33.6,41.8,32.7,43.2z M26.5,30.5c-0.8,0-1.5,0.1-2.1,0.3 c-2.6,0.7-4.4,2.3-5.6,4.4c-1.3,2.1-1.7,4.6-0.9,7.1c0.7,2.6,2.3,4.4,4.4,5.6c1.4,0.8,3,1.2,4.5,1.2c0.8,0,1.5-0.1,2.4-0.2 c2.6-0.7,4.4-2.3,5.6-4.4c1.3-2.1,1.6-4.5,1-6.9h0.4l1.4,2.3l0,0c0,5.9-4.7,10.8-10.7,10.8c-2.9,0-5.5-1.1-7.5-3.1 c-2-2-3.1-4.6-3.1-7.5c0-5.7,4.5-10.5,10.2-10.7L26.5,30.5L26.5,30.5z M28,36.1l-0.1-10.8h4.3v7.4c0,0.4,0.4,0.9,0.8,0.9H38 l4.9,8.9c0.1,0.2,0.3,0.4,0.6,0.4c0.2,0,0.5,0,0.6-0.1l2.1-1.3l0.9,1.7l-4,2.6l-5.8-9.4c-0.1-0.3-0.4-0.4-0.7-0.4L28,36.1L28,36.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,20.7c2.7,0,4.9-2.3,4.9-4.9s-2.3-5-4.9-5s-5,2.3-5,5S28.1,20.7,30.7,20.7z M28.2,15.8 c0-1.4,1.2-2.6,2.6-2.6s2.5,1.1,2.5,2.6c0,1.4-1.2,2.5-2.5,2.5S28.2,17.2,28.2,15.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType28);
export default __webpack_public_path__ + "static/media/aioa-icon-type-28.032e2e2e1659f57d301e151a3bb46c5f.svg";
export { ForwardRef as ReactComponent };